import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { ellipsisVertical } from 'ionicons/icons';

export default function MiTopBar({ onOpenMenu }) {
  return (
    <header className="mi-topbar">
      <IonButton
        type="button"
        fill="clear"
        className="mi-topbar__menu"
        aria-label="Abrir menu"
        onClick={onOpenMenu}
      >
        <IonIcon icon={ellipsisVertical} aria-hidden="true" />
      </IonButton>
    </header>
  );
}
